import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Link, media } from '@elseu/sdu-titan';
import styled from 'styled-components';

/**
 * The styled component for the Logo
 */
var Logo = styled(Link).attrs({
  'aria-label': 'Sdu logo'
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: center;\n  width: 32px;\n  height: 32px;\n\n  ", "\n\n  img,\n  svg {\n    width: 32px;\n    height: 32px;\n\n    ", "\n  }\n"], ["\n  align-self: center;\n  width: 32px;\n  height: 32px;\n\n  ", "\n\n  img,\n  svg {\n    width: 32px;\n    height: 32px;\n\n    ", "\n  }\n"])), media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 44px;\n    height: 44px;\n  "], ["\n    width: 44px;\n    height: 44px;\n  "]))), media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: 44px;\n      height: 44px;\n    "], ["\n      width: 44px;\n      height: 44px;\n    "]))));
/**
 * The DefaultLogo component
 */
var DefaultLogo = function () {
  return jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.7 56.7",
    children: [jsx("path", {
      fill: "#e42313",
      d: "M0 0h56.7v56.7H0z"
    }), jsx("path", {
      fill: "#fff",
      d: "M10.6 35.9c-2.8 0-3.9-.9-4.9-.9h-.8s.1-1.6.1-2.4c0-.8-.1-2.4-.1-2.4h1.3c0 2.8 1.8 4 4.5 4 2.2 0 4.2-.7 4.2-3.2s-2.5-3-5-4S5 24.7 5 21.5c0-3.1 2.6-5 6.6-5 2.4 0 3.3.5 4.5.5h.8s-.1 1.5-.1 2.3c0 .8.1 2.2.1 2.2h-1.3c0-1.4-.6-3.4-3.9-3.4-2.6.1-3.7.9-3.7 2.7 0 2.2 2.4 2.9 4.8 3.9 2.9 1.2 5.3 2.2 5.3 5.3-.1 3.6-3.3 5.9-7.5 5.9m19.6-11.6v8.3s-.8 1.1-2.6 1.1c-1.7 0-4-.9-4-5 0-3.6 1.9-5.1 4.2-5.1 1.5 0 2.4.7 2.4.7m5.3 10.6v-1.2c-.8-.3-1.3-.4-2.4-.6V14.3h-1.3c-1 .4-2.9 1-4.1 1.1v1.2c.8.3 1.3.5 2.4.7v5s-.8-.3-2.4-.3c-4 0-7.3 2.7-7.3 7.4 0 4.3 2.6 6.6 5.5 6.6 1.8 0 3.6-1 4.4-2v2h1.2c1.1-.4 2.8-1 4-1.1M49.2 36c.9-.4 2.7-1 3.9-1.1v-1.2c-.8-.3-1.3-.4-2.4-.6V22h-1.3c-1 .4-2.9.9-4.1 1.1v1.3c.8.3 1.3.5 2.4.7v7.3c-.5.6-1.4 1.3-2.9 1.3-1.8 0-2.7-.9-2.7-3V22h-1.3c-.8.4-2.8.9-4 1.1v1.3c.8.3 1.3.5 2.3.7v6.3c0 3.4 1.9 4.7 4.3 4.7 2.6 0 4.2-1.6 4.5-2.2V36h1.3z"
    })]
  });
};
/**
 * The NavigationLogo component
 */
var NavigationLogo = function (_a) {
  var logo = _a.logo;
  return jsx(Logo, {
    to: "/",
    children: logo || jsx(DefaultLogo, {})
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { NavigationLogo };
//# sourceMappingURL=NavigationLogo.js.map
